
// export  const  userShieldType ={DEFI:"deFiShield",WALLET: "walletShield",LIGHT_DEFI:"lightDeFi", LIGHT_NFT :'lightNFT'}
export  const  userShieldType = [["Wallet Shield","walletShield"],["DeFi Shield","deFiShield"],["Light Defi","lightDeFi"],["light NFT","lightNFT"],["Counterparty Risk ","partnersGuard"]]
